import { render } from "./SoundsLikeInput.vue?vue&type=template&id=1d0bf5cc"
import script from "./SoundsLikeInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SoundsLikeInput.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/SoundsLikeInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d0bf5cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d0bf5cc', __exports__)) {
    api.reload('1d0bf5cc', __exports__)
  }
  
  module.hot.accept("./SoundsLikeInput.vue?vue&type=template&id=1d0bf5cc", () => {
    api.rerender('1d0bf5cc', render)
  })

}


export default __exports__